import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { ROUTES } from '@/config/routes';
import { useDeleteOne, useGetOne, useUpdateOne } from '@/queries/admin';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, FormData } from './Form';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isDeleting, setIsDeleting] = useState(false);
  const { data: chatGroup } = useGetOne('chat-groups', id!, {
    enabled: Boolean(id) && !isDeleting,
  });
  const { mutateAsync: updateChatGroup } = useUpdateOne('chat-groups');
  const { mutateAsync: deleteChatGroup } = useDeleteOne('chat-groups');
  const [formData, setFormData] = useState<Partial<FormData> | null>(null);

  useEffect(() => {
    if (!chatGroup) return;
    setFormData({
      systemName: chatGroup.systemName,
      title: chatGroup.title,
      sort: chatGroup.sort,
    });
  }, [chatGroup]);

  const onSubmit = async (data: FormData) => {
    try {
      await updateChatGroup({ id: id!, data });
      toast.success('Группа чатов успешно обновлена');
      navigate(ROUTES.ADMIN.CHATS_GROUPS);
    } catch (error) {
      console.error('Error updating chat group:', error);
      toast.error('Произошла ошибка при обновлении группы чатов');
    }
  };

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteChatGroup({ id: id! });
      toast.success('Группа чатов успешно удалена');
      navigate(ROUTES.ADMIN.CHATS_GROUPS);
    } catch (error) {
      setIsDeleting(false);
      console.error('Error deleting chat group:', error);
      toast.error('Произошла ошибка при удалении группы чатов');
    }
  };

  if (!formData) return <LoadingSpinner className="mt-6" text="Загрузка..." />;

  return (
    <PageLayout
      breadcrumbs={[
        { label: 'Группы чатов', href: ROUTES.ADMIN.CHATS_GROUPS },
        { label: 'Редактирование', href: '' },
      ]}
    >
      <Form onDelete={handleDelete} onSubmit={onSubmit} formData={formData} />
    </PageLayout>
  );
};
